import React from 'react';
import styles from './RadioButton.module.scss';
import PropTypes from 'prop-types';

export const RadioButton = ({ id, value, label, currentValue, handleClick, ...props }) => {
    return (
        <div onClick={handleClick} className={styles['option']}>
            <input id={value} name={value} type="radio" readOnly checked={currentValue === value} />
            <div className={styles['option__radio']}></div>
            <span className={styles['option__radio__label']}>{label}</span>
        </div>
    );
};

RadioButton.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    currentValue: PropTypes.string,
    handleClick: PropTypes.func
};
